<template>
  <section class="container content-padding">
    <div class="row">
      <div class="col-12 text-center">
        <span class="h5">รูปภาพการให้บริการ และ เอกสารรับมอบงาน</span>
      </div>
    </div>

    <div class="row mt-3" v-if="orderReport">
      <div class="col-md-6 col-12">
        <div class="card">
          <div class="card-header">
            <span class="font-weight-bold">วันที่ใช้บริการ</span> <span v-if="orderReport.order_date"> {{ orderReport.order_date | prettyDate }} </span>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item"><span class="font-weight-bold">REF ID:</span>
              <template v-if="orderReport.credit_invoice">
                {{ orderReport.credit_invoice.reference }}
              </template>
            </li>
            <li class="list-group-item"><span class="font-weight-bold">BOOKING ID:</span> {{ orderReport.order_code }}</li>
            <li class="list-group-item"><span class="font-weight-bold">ชื่อที่พัก:</span> {{ orderReport.user_place ? orderReport.user_place.place_name : '' }}</li>
            <li class="list-group-item"><span class="font-weight-bold">ที่อยู่ที่พัก:</span>
              <span v-if="orderReport.user_place && orderReport.user_place.address">
              {{ orderReport.user_place.address }}
            </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            รูปภาพสถานที่
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-md-3" v-for="(photo, index) in filterByPhotoType(1)" :key="index">
                <div class="mt-3">
                  <img :src="photo.image_xl" @click="openGallery(index, 1)"
                       alt="" class="img-fluid" style="cursor: pointer;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            รูปภาพก่อนทำความสะอาด
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-md-3" v-for="(photo, index) in filterByPhotoType(2)" :key="index">
                <div class="mt-3">
                  <img :src="photo.image_xl" @click="openGallery(index, 2)"
                       alt="" class="img-fluid" style="cursor: pointer;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            รูปภาพหลังทำความสะอาด
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-md-3" v-for="(photo, index) in filterByPhotoType(3)" :key="index">
                <div class="mt-3">
                  <img :src="photo.image_xl" @click="openGallery(index, 3)"
                       alt="" class="img-fluid" style="cursor: pointer;">
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            เอกสารส่งมอบงาน
          </div>
          <div class="card-body">
            <div v-if="orderReport.image_signature">
              <img :src="orderReport.image_signature" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Gallery -->
    <Tinybox v-model="galleryIndex" :images="_.map(filterByPhotoType(photoTypeId), 'image_xl')" loop no-thumbs />
  </section>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

export default {
  name: 'BookingPartnerOrderReport',
  data () {
    return {
      orderReport: [],
      photoTypeId: null,
      galleryIndex: null
    }
  },
  methods: {
    filterByPhotoType (type = null) {
      return _.filter(this.orderReport.order_photo, (item) => {
        return item.photo_type_id === type
      })
    },
    async fetchPartnerOrderReport () {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$route.query.token}`
        }
      }
      const { data } = await axios.get(`/partners/${this.$route.params.id}/order/${this.$route.params.orderId}/report`, config)
      if (!data.error) {
        this.orderReport = data.orders
      } else {
        this.$swal({
          text: 'พบข้อผิดพลาด กรุณาแจ้งเจ้าหน้าที่หรือลองใหม่อีกครั้ง',
          type: 'error'
        })
      }
    },
    openGallery (index = 0, photoTypeId = null) {
      this.galleryIndex = index
      this.photoTypeId = photoTypeId
    }
  },
  created () {
    console.log(this.$route.params.id, this.$route.params.orderId)
    this.fetchPartnerOrderReport()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partner/BookingPartnerOrderReport.vue